<template lang="pug">
md-list.subproject-panel(:md-expand-single='true')
  md-list-item(:key="subproject.id" md-expand='' v-for="subproject in subprojects")
    span.md-list-item-text {{subproject.name}}
    md-list(slot='md-expand')
      article
        ProjectImageSwiper.project-swiper(:project="subproject" @imageZoom="imageToZoom")
      br
      figcaption.slogan(:style="getColorPropertyStyle(subproject, true)") "{{subproject.slogan}}"
      figcaption.descripcion(v-html="subproject.descripcion")
      FichaTecnicaPanel(:fichaTecnica="subproject.fichaTecnica" :costo="costo" :color="subproject.color" is-subproject)
      .documentTitle(:style="getColorPropertyStyle(subproject, true)") Estadísticas
      StatisticPanel(:color="color" :estadisticas="estadisticas.subProjects && estadisticas.subProjects[subproject.name]")
      .documentTitle(:style="getColorPropertyStyle(subproject, true)") Documentos
      DownloadPanel(:code="subproject.parentCode" :color="subproject.color" :documents="subproject.documents" baseUrl="/documents/projects/")

</template>

<script>
import colorPropertyMixin from '@/mixins/color-property.js'

export default {
  name: 'SubprojectPanel',
  mixins: [colorPropertyMixin],
  components: {
    DownloadPanel: _ => import('@/components/DownloadPanel'),
    ProjectImageSwiper: _ => import('@/components/map/solucion-definitiva/panel/ProjectImageSwiper'),
    FichaTecnicaPanel: _ => import('@/components/map/solucion-definitiva/panel/tab2/FichaTecnicaPanel'),
    StatisticPanel: _ => import('@/components/map/solucion-definitiva/panel/tab3/StatisticPanel')
  },
  props: {
    subprojects: Array,
    color: String,
    costo: [String, Number],
    estadisticas: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    imageToZoom (img) {
      this.$emit('subProjectOpenImgZoomDialog', img)
    }
  },
  computed: {

  }
}
</script>

<style scoped lang="stylus">
@import '~@/styles/variables'

.subproject-panel
  figcaption
    white-space: normal
  .descripcion
    padding: $f10px 0
  .slogan
    font: bold 1.2rem 'Roboto'
  .documentTitle
    padding-top: $f10px
    margin: 0 $f10px
    font: bold 1.5rem 'Roboto Condensed'
</style>
